import { StyleSheet } from '@react-pdf/renderer';

import { PDF_STYLES_CONSTANTS } from '../constants/pdfStylesConstants.ts';

const styles = StyleSheet.create({
  container: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.CONTENT_WIDTH_NARROW,
    left: PDF_STYLES_CONSTANTS.DIMENSIONS.LEFT_MARGIN,
    color: PDF_STYLES_CONSTANTS.COLORS.PRIMARY_DARK,
  },
  titleContent: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
    paddingBottom: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_MEDIUM,
    fontWeight: PDF_STYLES_CONSTANTS.FONT_WEIGHTS.NORMAL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.XX_LARGE,
  },
  row: {
    flexDirection: 'row',
    borderBottom: PDF_STYLES_CONSTANTS.BORDERS.THIN_GRAY,
    paddingVertical: PDF_STYLES_CONSTANTS.SPACING.PADDING_BOTTOM_SMALL,
    alignItems: 'center',
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.MEDIUM,
  },
  titleLine: {
    flexDirection: 'row',
    paddingVertical: PDF_STYLES_CONSTANTS.SPACING.PADDING_BOTTOM_SMALL,
    alignItems: 'center',
    borderBottom: PDF_STYLES_CONSTANTS.BORDERS.THICK_BLACK,
    fontWeight: PDF_STYLES_CONSTANTS.FONT_WEIGHTS.BOLD,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.MEDIUM_LARGE,
  },
  numberOfSection: {
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.SECTION_WIDTH,
    marginLeft: PDF_STYLES_CONSTANTS.SPACING.MARGIN_LEFT,
  },
  numberOfSectionTitleLine: {
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.SECTION_WIDTH,
  },
  titleOfPage: {
    flex: PDF_STYLES_CONSTANTS.LAYOUT.FLEX_FULL,
  },
  numberOfPage: {
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.SECTION_WIDTH,
    textAlign: 'right',
  },
});

export default styles;
